const SupportOrgSection = () => {
  const benefits = [
    {
      title: '業務効率化',
      description: '申請書類の作成業務を外部委託することで、本来の支援業務に集中できます。',
      icon: 'ri-speed-up-line',
    },
    {
      title: 'コスト削減',
      description: '専門スタッフを雇用するよりも、リーズナブルなコストで専門家のサポートを受けられます。',
      icon: 'ri-funds-line',
    },
    {
      title: '高い許可率',
      description: '豊富な経験と実績により、高い許可率を実現。不許可リスクを最小限に抑えます。',
      icon: 'ri-medal-line',
    },
    {
      title: '迅速な対応',
      description: '年中無休・深夜24時まで対応。お急ぎの案件にも柔軟に対応いたします。',
      icon: 'ri-flashlight-line',
    }
  ];

  const serviceItems = [
    { title: '申請書類作成代行', desc: '在留資格認定証明書交付申請、変更申請、更新申請の書類作成' },
    { title: '支援計画書作成', desc: '1号特定技能外国人支援計画の作成サポート' },
    { title: '入管申請代行', desc: '出入国在留管理局への申請取次' },
    { title: '相談対応', desc: '特定技能ビザに関する各種相談対応' },
    { title: '複数案件対応', desc: '2件目以降は割引料金でご提供' },
    { title: '定期的な情報提供', desc: '法改正や最新情報の共有' },
  ];

  return (
    <section id="support-org" className="py-16 md:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* セクションヘッダー */}
        <div className="flex items-start gap-4 md:gap-6 mb-10 md:mb-16">
          <div className="flex-shrink-0 pt-1">
            <div className="w-px h-12 md:h-16 bg-[#1a3a5c]"></div>
          </div>
          <div>
            <p className="text-[#1a3a5c] text-xs tracking-[0.3em] font-medium uppercase mb-2">For Support Organizations</p>
            <h2
              className="text-2xl md:text-4xl font-bold text-slate-800 mb-3"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              登録支援機関・人材紹介会社の方へ
            </h2>
            <p className="text-slate-500 text-sm">貴社の業務効率化をサポートいたします</p>
          </div>
        </div>

        {/* 写真＋メリット */}
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 mb-10 md:mb-16 items-center">
          {/* 左：メリット */}
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white border border-slate-200 p-4 md:p-6 hover:border-blue-400 transition-colors duration-300 group"
              >
                <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-slate-100 group-hover:bg-[#1a3a5c] transition-colors duration-300 mb-3 md:mb-4">
                  <i className={`${benefit.icon} text-slate-600 group-hover:text-blue-300 text-base md:text-lg transition-colors duration-300`}></i>
                </div>
                <h3 className="font-bold text-slate-800 text-xs md:text-sm mb-1 md:mb-2"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  {benefit.title}
                </h3>
                <p className="text-slate-500 text-xs leading-relaxed hidden sm:block">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          {/* 右：写真 */}
          <div className="relative">
            <div className="w-full h-[240px] md:h-[400px] overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/6b42c73ab764808bfbff67e61111b58a.jpg"
                alt="登録支援機関サポート"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 w-full h-full border-2 border-[#1a3a5c]/25 -z-10 hidden md:block"></div>
          </div>
        </div>

        {/* 提供サービス */}
        <div className="bg-white border border-slate-200 p-6 md:p-10 mb-8 md:mb-12">
          <h3 className="text-lg md:text-xl font-bold text-slate-800 mb-6 md:mb-8 flex items-center gap-3"
            style={{ fontFamily: "'Noto Serif JP', serif" }}>
            <div className="w-1 h-6 bg-[#1a3a5c]"></div>
            提供サービス
          </h3>
          <div className="grid sm:grid-cols-2 gap-4 md:gap-6">
            {serviceItems.map((item, i) => (
              <div key={i} className="flex items-start gap-3 md:gap-4">
                <div className="w-6 h-6 flex items-center justify-center bg-[#1a3a5c] flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-blue-300 text-xs"></i>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800 text-sm mb-0.5">{item.title}</h4>
                  <p className="text-slate-500 text-xs leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTAバナー */}
        <div className="bg-[#1a3a5c] px-6 md:px-10 py-7 md:py-8 flex flex-col md:flex-row items-center justify-between gap-5 md:gap-6">
          <div className="text-center md:text-left">
            <p className="text-blue-300 text-xs tracking-[0.3em] uppercase mb-2">Contact Us</p>
            <p className="text-white text-lg md:text-xl font-bold" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              まずはお気軽にご相談ください
            </p>
            <p className="text-white/60 text-sm mt-1">
              貴社の業務内容に合わせた最適なサポートプランをご提案いたします
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0 w-full md:w-auto">
            <a
              href="tel:06-7777-3813"
              className="inline-flex items-center justify-center gap-3 border border-blue-300 text-blue-200 hover:bg-blue-600 hover:text-white hover:border-blue-400 px-6 md:px-8 py-3 md:py-4 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-lg"></i>
              <div>
                <p className="text-xs opacity-70 leading-none mb-0.5">代表電話</p>
                <span className="font-bold tracking-wider">06-7777-3813</span>
              </div>
            </a>
            <a
              href="tel:070-9096-1669"
              className="inline-flex items-center justify-center gap-3 border border-blue-300 text-blue-200 hover:bg-blue-600 hover:text-white hover:border-blue-400 px-6 md:px-8 py-3 md:py-4 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-smartphone-line text-lg"></i>
              <div>
                <p className="text-xs opacity-70 leading-none mb-0.5">代表直通</p>
                <span className="font-bold tracking-wider">070-9096-1669</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportOrgSection;
